module.exports = __webpack_public_path__ + "static/media/rails.25a6dd09.svg";